import React from "react";
import { useParams } from "react-router-dom";
import mockIP from "./mockIP";
import "./IPDetail.scss";

const IPDetail = () => {
  const { id } = useParams();

  const product = mockIP.find((p) => p.id === parseInt(id));

  return (
    <div className="IPDetail">
      <div className="IPDetail-card">
        <div className="IPDetail-card_imgs">
          <img
            className="IPDetail-card_imgs--img"
            src={`${process.env.PUBLIC_URL}/${product.img2}`}
          />
          <img
            className="IPDetail-card_imgs--img"
            src={`${process.env.PUBLIC_URL}/${product.img}`}
          />
          <img
            className="IPDetail-card_imgs--img"
            src={`${process.env.PUBLIC_URL}/${product.img3}`}
          />
        </div>
        <h2 className="IPDetail-card_model">{product.model}</h2>
        <p className="IPDetail-card_propertis">{product.propertisA}</p>
        <p className="IPDetail-card_propertis">{product.propertis1}</p>
        <p className="IPDetail-card_propertis">{product.propertis2}</p>
        <p className="IPDetail-card_propertis">{product.propertis3}</p>
        <p className="IPDetail-card_propertis">{product.propertis4}</p>
        <p className="IPDetail-card_propertis">{product.propertis5}</p>
        <p className="IPDetail-card_propertis">{product.propertisB}</p>
        <p className="IPDetail-card_propertis">{product.propertis6}</p>
        <p className="IPDetail-card_propertis">{product.propertis7}</p>
        <p className="IPDetail-card_propertis">{product.propertis8}</p>
        <p className="IPDetail-card_propertis">{product.propertis9}</p>
        <p className="IPDetail-card_propertis">{product.propertis10}</p>
      </div>
      <div className="IPDetail-colors">
        <img
          className="IPDetail-colors_img"
          src={`${process.env.PUBLIC_URL}/${product.colors}`}
        />
      </div>
    </div>
  );
};

export default IPDetail;
